module.exports = __webpack_public_path__ + "media/images/site/CENSINO_FUND_2_NOSSA_METODOLOGIA-a0059a980580f0fbfd6248ce9b14d32b.jpg";